module.exports = __webpack_public_path__ + "img/SISAMEX.ddbbf6e9.png";